import Tabs from "./tabs";
import Tab from "./tab";
import TabsPlaceholder from "./tabsPlaceholder";

export { Tab, TabsPlaceholder };
export default Tabs;
